import { createActionCreator } from '@pressreader/appstore';
import { AnyProduct } from '@pressreader/commerce-types';

import { MODULE_NAME } from '../constants';

const pre = MODULE_NAME + '/';

interface IssuePurchaseRequestPayload {
    product: AnyProduct;
    issueKey: string;
}

const purchaseDone = createActionCreator(`${pre}purchase_done`);
const issuePurchaseRequestDone = createActionCreator(`${pre}issue_purchase_request_done`);

const issuePurchaseRequestAction = createActionCreator<IssuePurchaseRequestPayload>(`${pre}issue_purchase_request`);

export { purchaseDone, issuePurchaseRequestDone, issuePurchaseRequestAction };
